
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/j/[id]",
      function () {
        return require("private-next-pages/j/[id].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/j/[id]"])
      });
    }
  